import { KeyboardArrowLeft } from "@mui/icons-material";
import { Box, IconButton, Stack, Typography, useTheme } from "@mui/material";

import Button from "@components/Button";

import { ReactComponent as GawainIcon } from "@assets/icons/gawain_ai.svg";

type GawainAIProps = {
  isFreelancer?: boolean;
  onBack?: () => void;
};
const GawainAI = ({ isFreelancer, onBack }: GawainAIProps) => {
  const {
    palette: { common },
  } = useTheme();

  return (
    <Stack flex={1} height={"100%"} p={2} gap={1} overflow={"auto"}>
      {/* <Stack px={2} py={1} gap={1.5} flex={1}> */}
      <Stack>
        <IconButton sx={{ width: "40px" }} onClick={onBack}>
          <KeyboardArrowLeft />
        </IconButton>
      </Stack>
      <Stack flexGrow={1} alignItems={"center"} gap={6} mt={10}>
        <Box>
          <GawainIcon />
        </Box>
        <Typography textAlign={"center"} color={"#000000A3"} fontSize={14}>
          Gawain.AI is currently available only to a select group of beta testers.
        </Typography>
        <Typography textAlign={"center"} color={"#000000A3"} fontSize={14}>
          Please fill out the form below to secure your spot and be one of the first to
          try Gawain.AI!
        </Typography>
        {/* </Stack> */}
        <Button
          sx={{
            borderRadius: 2,
            bgcolor: "#000000",
          }}
        >
          Access Google Form
        </Button>
      </Stack>
    </Stack>
  );
};
export default GawainAI;
